<template>
    <div class="container mt-4 mb-5 px-2" v-if="Redeems && Redeems.products && Redeems.products.length">
        <div class="container px-3">
            <div class="row d-flex align-items-center">
                <div :class="{
                    'col-6' : !isStaffUser,
                    'col-md-8' : !isStaffUser,
                    'col-12': isStaffUser
                }">
                    <h5 class="mb-2 text-title-bat">{{ (!isStaffUser) ? Redeems.title : 'Antójate con lo que tenemos ¡PARA TI!' }}</h5>
                </div>
                <div v-if="!isStaffUser" class="col-6 col-md-4">
                    <div class="col-12 d-flex align-items-end px-0 px-md-3 container py-3 flex-row-reverse">
                        <a id="boton-ver-catalogo" title="ver catalogo" class="text-secondary text-title-bat text-decoration-underline fs-6 " href="/catalogo" ><b>Ver catálogo ></b></a>
                    </div>
                </div>
            </div>
        </div>
        <div class="mb-3">
            <slick ref="slick" :options="slickOptionsRedeem" class="slick-redeem-home">
                <div v-for="(product, index) in Redeems.products" :key="index" v-if="$mq === 'xl' ? index < 6 : index < 7" class="px-2 px-mg-2 col-3 col-sm-3 col-lg-2">
                    <div class="cursor-pointer mx-1 mx-md-3 mx-lg-3 d-flex flex-column justify-content-between">
                        <a :id="product.id + '-detalle-canjea'" :title="product.name + '-' + product.category" class="text-product-card" :href="'/catalog-category/' + product.ID + '/product-detail/' + product.guid">
                            <div class="p-1">
                                <div class="divImg aling-items-center shadow rounded-4 position-relative d-flex justify-content-center mb-2 w-100 ">
                                    <div class="position-absolute rounded-1 top-0 start-0 bg-lighterblue p-1 px-2 object-fit-contain"><p class="mb-0 text-bat text-dark"><small>{{ product.category }}</small></p></div>
                                    <img v-if="product.image" :src="url_media + product.image.slice(1,product.image.length)" :alt="product.tittle" class="w-100 h-100 rounded-4">
                                    <img v-else src="/img/default_image.png" :alt="product.tittle" class="w-100 h-100 rounded-4 img-fluid rounded-4">
                                </div>
                            </div>
                            <div>
                                <p class="fs-6 mb-1 text-title-bat"><b class="fs-6">{{ product.value_points }}</b> Puntos</p>
                                <p class="text-bat fs-6 fw-bold text-bat text-indigo-darkness texto-truck-descript mb-2">{{ product.name }}</p>
                            </div>
                            <div class="text-center d-flex justify-content-center">
                                <button type="button" class="w-100 mx-1 btn btnBlue text-title-bat rounded-3">Ver detalle</button>
                            </div>
                        </a>
                    </div>
                </div>
                <a id="boton-ver-todos" title="ver todos" v-if="this.activeCategory == 1 && !isStaffUser" href="/catalogo?category=outStanding" class="px-2 px-mg-2 col-3 col-sm-3 col-lg-2">
                    <div class="cursor-pointer mx-1 mx-md-3 mx-lg-4 d-flex flex-column justify-content-between">
                        <img src="/img-version2/icons/Cards_pedido_V2.svg"  class="w-100 h-100">
                    </div>
                </a>
            </slick>
        </div>
        <div v-if="isStaffUser" class="mb-3">
            <div class="row">
                <div class="col-12 col-md-12 col-lg-4 col-xl-4">
                    <a class="w-100 mx-1 btn text-title-bat rounded-3 btn-season" href="/catalogo">
                        <span>Ver Catálogo </span>
                    </a>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
import Slick from 'vue-slick';
import 'slick-carousel/slick/slick.css';
export default {
    props: {
        client_segment : null,
        staff_segments : null,
    },
    components: { Slick },
    data() {
        return {
            Redeems: [],
            url_media:"",
            activeCategory: null,
            slickOptionsRedeem: {
                dots: false,
                arrows: false,
                infinite: true,
                centerMode: false,
                autoplay: false,
                slidesToShow: 7,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 1440,
                        settings: {
                            slidesToShow: 6,
                            slidesToScroll: 1,
                            initialSlide: 1,
                            infinite: true,
                        }
                    },
                    {
                        breakpoint: 1250,
                        settings: {
                            slidesToShow: 6,
                            slidesToScroll: 1,
                            initialSlide: 1,
                            infinite: true,
                        }
                    },
                    {
                        breakpoint: 850,
                        settings: {
                            slidesToShow: 4.15,
                            slidesToScroll: 1,
                            initialSlide: 1,
                            infinite: true,
                        }
                    },
                    {
                        breakpoint: 630,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            initialSlide: 1,
                            infinite: true,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 2.2,
                            slidesToScroll: 1,
                            initialSlide: 1,
                            infinite: true,
                        }
                    }
                ],
            },
        }
    },
    mounted () {
        this.loadOutstanding();
    },
    computed: {
        isStaffUser() {
            const isStaff = this.staff_segments.includes(this.client_segment);
            return isStaff;
        }
    },
    methods: {
        loadOutstanding(){
            axios.get(`/get-outstanding-products`)
            .then((data) => {
                this.activeCategory = data.data.active
                this.Redeems = data.data;
                this.url_media = data.data.url_media;
            })
        },
    }
}
</script>
